import { Fragment, useEffect, useState } from 'react';

import { getTranslatedStoreValue } from '@/components/StoresList/utils';
import type { StoreHit } from '@/integrations/algolia/types';
import { useRegionProvider } from '@/providers/RegionProvider';

import type { PhotoGalleryItem } from '../../cms';
import { BoutiqueStorySlider } from '../BoutiqueStorySlider/BoutiqueStorySlider';

import * as S from './BoutiqueStory.styles';
interface BoutiqueStoryProps {
  boutiqueHit: StoreHit;
}

export const BoutiqueStory = ({ boutiqueHit }: BoutiqueStoryProps) => {
  const { locale } = useRegionProvider();
  const langSlug = locale.slug;
  const descriptionText = () => {
    return getTranslatedStoreValue(boutiqueHit, 'description', langSlug) ?? '';
  };
  const [spaceBetween, setSpaceBetween] = useState(1);
  useEffect(() => {
    setSpaceBetween(0);
  }, []);
  const imagesWithoutFirst = boutiqueHit?.photo_gallery
    ?.map((item: PhotoGalleryItem) => item.image.url)
    .filter((_, index) => index !== 0);
  return (
    <S.BoutiqueStoryContainer>
      <S.LimitedWidth>
        <S.FlexContainer>
          <S.SlidersContainer>
            <BoutiqueStorySlider slidesPerView={1} spaceBetween={spaceBetween}>
              {imagesWithoutFirst?.map((img) => {
                return (
                  <Fragment key={img}>
                    <S.StyledAspectRatioImage
                      alt='boutique image'
                      aspectRatio={{ x: 4, y: 3 }}
                      focalPoint={{ x: 960, y: 262 }}
                      loaderProps={{ height: 240 }}
                      loading='lazy'
                      originalImageDimensions={undefined}
                      showFallbackPlaceholder
                      sizes='50vw'
                      src={img}
                      useLoader
                      width='100%'
                    />
                  </Fragment>
                );
              })}
            </BoutiqueStorySlider>
          </S.SlidersContainer>
          <S.TextContainer>
            <S.Text>{boutiqueHit && descriptionText()}</S.Text>
          </S.TextContainer>
        </S.FlexContainer>
      </S.LimitedWidth>
    </S.BoutiqueStoryContainer>
  );
};
